import {
    Backdrop,
    Button,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    CircularProgress,
    Container,
    Divider,
    Grid,
    IconButton,
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    createTheme,
    Dialog, DialogTitle, DialogActions, DialogContent,
    List, ListItem, ListItemIcon, ListItemText,
    Typography,
    TableSortLabel,
    Paper,
    Chip,
    Tooltip,
    Fade,
    Box,
    Slide
} from '@material-ui/core';
import Alert from 'src/components/Alert';
import MuiAlert from '@material-ui/lab/Alert';
import { ThemeProvider, makeStyles } from '@material-ui/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getUser } from 'src/utils/Common';
import Page from 'src/components/Page';
import ListItemButton from '@material-ui/core/ListItemAvatar';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import CloseIcon from '@material-ui/icons/Close';
import FolderIcon from '@material-ui/icons/Folder';
import Tarihce from 'src/views/History';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'src/utils/axios';
import moment from 'moment';
import ServiceDigitalForms from 'src/components/ServiceDigitalForms';
import ServiceDigitalFormsPrint from 'src/components/ServiceDigitalFormsPrint';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import BlockIcon from '@material-ui/icons/Block';
import AssignmentIcon from '@material-ui/icons/Assignment';
import FilterListIcon from '@material-ui/icons/FilterList';
import HistoryIcon from '@material-ui/icons/History';
import ListAltIcon from '@material-ui/icons/ListAlt';

const materialTheme = createTheme({
    palette: {
        primary: {
            contrastText: '#FF9800',
            dark: '#424242',
            main: '#424242',
            light: '#424242'
        }
    }
});

const localeMap = {
    tr: trLocale
};

// ==========================================
// UTILITY FUNCTIONS (Component dışında)
// ==========================================

// Sorting utility fonksiyonları
const descendingComparator = (a, b, orderBy) => {
    // Handle null values
    if (a[orderBy] === null && b[orderBy] !== null) return 1;
    if (a[orderBy] !== null && b[orderBy] === null) return -1;
    if (a[orderBy] === null && b[orderBy] === null) return 0;
    
    // Handle undefined values
    if (typeof a[orderBy] === 'undefined' && typeof b[orderBy] !== 'undefined') return 1;
    if (typeof a[orderBy] !== 'undefined' && typeof b[orderBy] === 'undefined') return -1;
    if (typeof a[orderBy] === 'undefined' && typeof b[orderBy] === 'undefined') return 0;

    // Handle number vs string
    if (typeof a[orderBy] === 'number' && typeof b[orderBy] === 'string') return 1;
    if (typeof a[orderBy] === 'string' && typeof b[orderBy] === 'number') return -1;
    
    // Handle numbers
    if (typeof a[orderBy] === 'number' && typeof b[orderBy] === 'number') {
        return b[orderBy] - a[orderBy];
    }

    // Handle strings
    return (b[orderBy] || '').localeCompare(a[orderBy] || '');
};

const getComparator = (order, orderBy) => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};

const stableSort = (array, comparator) => {
    if (!array || array.length === 0) return [];
    
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};

// Durum listesinden ID array oluştur
const getDurumIdList = (selectedDurum) => {
    return selectedDurum.map(item => item.DURUM_ID);
};

// ==========================================
// STYLES (Component dışında - performans için)
// ==========================================
const useStyles = makeStyles(theme => ({
        root: {
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            backgroundColor: '#f5f5f5',
            minHeight: '100vh'
        },
        rootlist: {
            width: '100%',
            backgroundColor: theme.palette.background.paper,
            position: 'relative',
            overflow: 'auto',
            maxHeight: 550
        },
        rootlistsag: {
            width: '100%',
            backgroundColor: theme.palette.background.paper,
            position: 'relative',
            overflow: 'auto',
            maxHeight: 500
        },
        cardBolum: {
            maxHeight: 700,
            minHeight: 700,
            width: '100%'
        },
        table: {
            minWidth: 650
        },
        content: {
            minHeight: 550
        },
        chatSection: {
            width: '100%'
        },
        avatar: {
            cursor: 'pointer',
            width: 40,
            height: 40
        },
        headBG: {
            backgroundColor: '#e0e0e0'
        },
        borderRight500: {
            borderRight: '1px solid #e0e0e0'
        },
        messageArea: {
            overflowY: 'auto'
        },
        button: {
            margin: theme.spacing(1)
        },
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff'
        },
        actionsCCFile: {
            justifyContent: 'flex-end'
        },
        responsiveContainer: {
            marginTop: theme.spacing(3),
            [theme.breakpoints.between('md', 'lg')]: {
                maxHeight: '70vh',
                overflowX: 'hidden',
                overflowY: 'scroll'
            },
            [theme.breakpoints.down('sm')]: {
                maxHeight: '60vh',
                overflow: 'scroll'
            }
        },
        action: {
            display: 'flex',
            alignItems: 'center',
            marginLeft: 'auto',
            paddingLeft: 16,
            marginRight: 10,
            borderRadius: 10,
            [theme.breakpoints.down('xs')]: {
                width: '100%',
                margin: 0
            }
        },
        // Yeni UI İyileştirme Stilleri
        mainCard: {
            borderRadius: 16,
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            overflow: 'hidden'
        },
        cardHeaderCustom: {
            background: '#f8f9fa',
            color: '#FF9800',
            padding: theme.spacing(2, 3),
            borderBottom: '2px solid #e0e0e0',
            '& .MuiCardHeader-title': {
                fontWeight: 600,
                fontSize: '1.25rem',
                color: '#FF9800'
            }
        },
        filterSection: {
            padding: theme.spacing(2.5),
            marginBottom: theme.spacing(2),
            borderRadius: 12,
            backgroundColor: '#fafafa',
            border: '1px solid #e0e0e0'
        },
        filterTitle: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: theme.spacing(2),
            color: '#424242',
            fontWeight: 500,
            '& svg': {
                marginRight: theme.spacing(1),
                color: '#FF9800'
            }
        },
        searchButton: {
            background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
            color: '#fff',
            borderRadius: 8,
            padding: '10px 24px',
            fontWeight: 600,
            textTransform: 'none',
            boxShadow: '0 4px 12px rgba(255, 152, 0, 0.3)',
            transition: 'all 0.3s ease',
            '&:hover': {
                background: 'linear-gradient(135deg, #F57C00 0%, #EF6C00 100%)',
                boxShadow: '0 6px 16px rgba(255, 152, 0, 0.4)',
                transform: 'translateY(-2px)'
            }
        },
        createButton: {
            background: 'linear-gradient(135deg, #4CAF50 0%, #388E3C 100%)',
            color: '#fff',
            borderRadius: 8,
            padding: '10px 24px',
            fontWeight: 600,
            textTransform: 'none',
            boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)',
            transition: 'all 0.3s ease',
            '&:hover': {
                background: 'linear-gradient(135deg, #388E3C 0%, #2E7D32 100%)',
                boxShadow: '0 6px 16px rgba(76, 175, 80, 0.4)',
                transform: 'translateY(-2px)'
            }
        },
        tableContainer: {
            borderRadius: 12,
            overflow: 'hidden',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
        },
        tableHead: {
            backgroundColor: '#f8f9fa',
            '& th': {
                fontWeight: 600,
                color: '#424242',
                borderBottom: '2px solid #e0e0e0',
                padding: theme.spacing(1.5, 2),
                whiteSpace: 'nowrap'
            }
        },
        tableRow: {
            transition: 'all 0.2s ease',
            '&:nth-of-type(odd)': {
                backgroundColor: '#fafafa'
            },
            '&:hover': {
                backgroundColor: '#fff3e0 !important',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
            }
        },
        tableRowSelected: {
            backgroundColor: '#FFE0B2 !important',
            '&:hover': {
                backgroundColor: '#FFCC80 !important'
            }
        },
        tableCell: {
            padding: theme.spacing(1.5, 2),
            borderBottom: '1px solid #f0f0f0'
        },
        actionButton: {
            margin: theme.spacing(0, 0.5),
            transition: 'all 0.2s ease',
            '&:hover': {
                transform: 'scale(1.1)'
            }
        },
        commentButton: {
            backgroundColor: '#2196F3',
            color: '#fff',
            '&:hover': {
                backgroundColor: '#1976D2'
            }
        },
        viewFormButton: {
            backgroundColor: '#FF9800',
            color: '#fff',
            '&:hover': {
                backgroundColor: '#F57C00'
            }
        },
        approveButton: {
            backgroundColor: '#4CAF50',
            color: '#fff',
            '&:hover': {
                backgroundColor: '#388E3C'
            }
        },
        statusChip: {
            fontWeight: 500,
            fontSize: '0.75rem'
        },
        statusPending: {
            backgroundColor: '#FFF3E0',
            color: '#E65100',
            border: '1px solid #FFB74D'
        },
        statusApproved: {
            backgroundColor: '#E8F5E9',
            color: '#2E7D32',
            border: '1px solid #81C784'
        },
        statusRejected: {
            backgroundColor: '#FFEBEE',
            color: '#C62828',
            border: '1px solid #E57373'
        },
        statusInfo: {
            backgroundColor: '#E3F2FD',
            color: '#1565C0',
            border: '1px solid #64B5F6'
        },
        statusCanceled: {
            backgroundColor: '#FAFAFA',
            color: '#757575',
            border: '1px solid #BDBDBD'
        },
        emptyState: {
            textAlign: 'center',
            padding: theme.spacing(8, 2),
            color: '#9e9e9e'
        },
        emptyStateIcon: {
            fontSize: 80,
            color: '#e0e0e0',
            marginBottom: theme.spacing(2)
        },
        emptyStateText: {
            fontSize: '1.1rem',
            marginBottom: theme.spacing(1)
        },
        emptyStateSubtext: {
            fontSize: '0.875rem',
            color: '#bdbdbd'
        },
        // Uyarı/Bildirim Stilleri
        snackbar: {
            top: 24
        },
        alertSuccess: {
            background: 'linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)',
            color: '#fff',
            borderRadius: 12,
            boxShadow: '0 8px 32px rgba(76, 175, 80, 0.3)',
            padding: theme.spacing(1.5, 2),
            fontSize: '0.95rem',
            fontWeight: 500,
            alignItems: 'center',
            '& .MuiAlert-icon': {
                color: '#fff',
                fontSize: 28,
                opacity: 1
            },
            '& .MuiAlert-action': {
                color: '#fff',
                '& .MuiIconButton-root': {
                    color: '#fff'
                }
            }
        },
        alertError: {
            background: 'linear-gradient(135deg, #f44336 0%, #c62828 100%)',
            color: '#fff',
            borderRadius: 12,
            boxShadow: '0 8px 32px rgba(244, 67, 54, 0.3)',
            padding: theme.spacing(1.5, 2),
            fontSize: '0.95rem',
            fontWeight: 500,
            alignItems: 'center',
            '& .MuiAlert-icon': {
                color: '#fff',
                fontSize: 28,
                opacity: 1
            },
            '& .MuiAlert-action': {
                color: '#fff',
                '& .MuiIconButton-root': {
                    color: '#fff'
                }
            }
        },
        alertWarning: {
            background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
            color: '#fff',
            borderRadius: 12,
            boxShadow: '0 8px 32px rgba(255, 152, 0, 0.3)',
            padding: theme.spacing(1.5, 2),
            fontSize: '0.95rem',
            fontWeight: 500,
            alignItems: 'center',
            '& .MuiAlert-icon': {
                color: '#fff',
                fontSize: 28,
                opacity: 1
            },
            '& .MuiAlert-action': {
                color: '#fff',
                '& .MuiIconButton-root': {
                    color: '#fff'
                }
            }
        },
        alertInfo: {
            background: 'linear-gradient(135deg, #2196F3 0%, #1565C0 100%)',
            color: '#fff',
            borderRadius: 12,
            boxShadow: '0 8px 32px rgba(33, 150, 243, 0.3)',
            padding: theme.spacing(1.5, 2),
            fontSize: '0.95rem',
            fontWeight: 500,
            alignItems: 'center',
            '& .MuiAlert-icon': {
                color: '#fff',
                fontSize: 28,
                opacity: 1
            },
            '& .MuiAlert-action': {
                color: '#fff',
                '& .MuiIconButton-root': {
                    color: '#fff'
                }
            }
        },
        // Dialog Stilleri
        dialogPaper: {
            borderRadius: 16,
            overflow: 'hidden'
        },
        dialogTitle: {
            background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
            color: '#fff',
            padding: theme.spacing(2, 3),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            '& .MuiTypography-root': {
                fontWeight: 600,
                fontSize: '1.1rem'
            }
        },
        dialogTitleHistory: {
            background: 'linear-gradient(135deg, #2196F3 0%, #1565C0 100%)',
            color: '#fff',
            padding: theme.spacing(2, 3),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        dialogTitleApprove: {
            background: 'linear-gradient(135deg, #4CAF50 0%, #388E3C 100%)',
            color: '#fff',
            padding: theme.spacing(2, 3),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        dialogCloseButton: {
            color: '#fff',
            backgroundColor: 'rgba(255,255,255,0.1)',
            '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.2)'
            }
        },
        dialogContent: {
            padding: theme.spacing(3)
        },
        dialogActions: {
            padding: theme.spacing(2, 3),
            backgroundColor: '#fafafa',
            borderTop: '1px solid #e0e0e0',
            gap: theme.spacing(1)
        },
        // Onay/Red Butonları
        rejectButton: {
            background: 'linear-gradient(135deg, #f44336 0%, #c62828 100%)',
            color: '#fff',
            borderRadius: 8,
            padding: '10px 24px',
            fontWeight: 600,
            textTransform: 'none',
            boxShadow: '0 4px 12px rgba(244, 67, 54, 0.3)',
            transition: 'all 0.3s ease',
            '&:hover': {
                background: 'linear-gradient(135deg, #c62828 0%, #b71c1c 100%)',
                boxShadow: '0 6px 16px rgba(244, 67, 54, 0.4)',
                transform: 'translateY(-2px)'
            }
        },
        approveButtonLarge: {
            background: 'linear-gradient(135deg, #4CAF50 0%, #388E3C 100%)',
            color: '#fff',
            borderRadius: 8,
            padding: '10px 24px',
            fontWeight: 600,
            textTransform: 'none',
            boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)',
            transition: 'all 0.3s ease',
            '&:hover': {
                background: 'linear-gradient(135deg, #388E3C 0%, #2E7D32 100%)',
                boxShadow: '0 6px 16px rgba(76, 175, 80, 0.4)',
                transform: 'translateY(-2px)'
            }
        },
        closeButton: {
            background: 'linear-gradient(135deg, #9e9e9e 0%, #757575 100%)',
            color: '#fff',
            borderRadius: 8,
            padding: '10px 24px',
            fontWeight: 600,
            textTransform: 'none',
            boxShadow: '0 4px 12px rgba(158, 158, 158, 0.3)',
            transition: 'all 0.3s ease',
            '&:hover': {
                background: 'linear-gradient(135deg, #757575 0%, #616161 100%)',
                boxShadow: '0 6px 16px rgba(158, 158, 158, 0.4)',
                transform: 'translateY(-2px)'
            }
        },
        // Loading/Backdrop Stilleri
        backdropContent: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: theme.spacing(2)
        },
        loadingText: {
            color: '#fff',
            fontSize: '1rem',
            fontWeight: 500,
            marginTop: theme.spacing(2)
        },
        // İstatistik Bölümü
        statsSection: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: theme.spacing(1.5, 2),
            marginBottom: theme.spacing(1),
            backgroundColor: '#fff',
            borderRadius: 8,
            border: '1px solid #e0e0e0'
        },
        statsText: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(1),
            color: '#666',
            fontSize: '0.875rem'
        },
        statsCount: {
            fontWeight: 700,
            color: '#FF9800',
            fontSize: '1.1rem'
        },
        // Yorum TextField
        commentField: {
            '& .MuiOutlinedInput-root': {
                borderRadius: 12,
                '&:hover fieldset': {
                    borderColor: '#FF9800'
                },
                '&.Mui-focused fieldset': {
                    borderColor: '#FF9800'
                }
            },
            '& .MuiInputLabel-root.Mui-focused': {
                color: '#FF9800'
            }
        }
    }));

// ==========================================
// COMPONENT
// ==========================================
function LaborManagement() {
    const classes = useStyles();
    
    // Checkbox ikonları
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#FF9800' }} />;

    // State tanımlamaları
    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const SessionUser = getUser();
    const [anketBitti, setAnketBitti] = useState(false);
    const [printAnket, setPrintAnket] = useState(false);
    const [singlePopUp, setSinglePopUp] = useState(false);
    const [yorumAciklama, setYorumAciklama] = useState('');

    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    const [durum, setDurum] = useState([]);
    const [selectedDurum, setSelectedDurum] = useState([]);

    const [talepEdilmeBaslangicTarihi, setTalepEdilmeBaslangicTarihi] = useState(
        new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toString()
    );

    const [talepEdilmeBitisTarihi, setTalepEdilmeBitisTarihi] = useState(
        new Date().toString()
    );

    // Memoized değerler (performans için)
    const formattedBaslangicDate = useMemo(() => 
        moment(talepEdilmeBaslangicTarihi).format('MM-DD-YYYY'), 
        [talepEdilmeBaslangicTarihi]
    );
    
    const formattedBitisDate = useMemo(() => 
        moment(talepEdilmeBitisTarihi).format('MM-DD-YYYY'), 
        [talepEdilmeBitisTarihi]
    );

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedDurumId, setSelectedDurumId] = useState(0);
    const [tarihcePopUp, setTarihcePopUp] = useState(false);
    const [filePopUp, setFilePopUp] = useState(false);
    const [fileList, setFileList] = React.useState([]);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('SURECTIPI');
    const [formTypes, setFormTypes] = useState([]);
    const [anketGoster, setAnketGoster] = useState(false);
    const [anketData, setAnketData] = useState({});
    const [formData, setFormData] = useState({});
    const [readOnly, setReadOnly] = useState(false);
    const [mesaj, setMesaj] = useState('');
    const [documents, setDocuments] = useState([]);
    const [Required, setRequired] = useState(false);

    // ==========================================
    // API FUNCTIONS
    // ==========================================
    
    // Durum adımlarını getir
    const getLaborSteps = useCallback(async () => {
        try {
            const response = await axios.get("/getLaborSteps");
            setDurum(response.data || []);
        } catch (error) {
            console.error("Durum adımları yüklenirken hata:", error);
            setresponseMessage('Durum adımları yüklenemedi');
            setUyariTip('error');
            setUyari(true);
        }
    }, []);

    // Form kategorilerini getir
    const getServiceFormCategories = useCallback(async () => {
        setLoading(true);
        try {
            const response = await axios.get('getLaborFormCategories');
            setFormTypes(response.data?.FormTypes || []);
        } catch (error) {
            console.error("Form kategorileri yüklenirken hata:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    // Hizmet formlarını getir (birleştirilmiş fonksiyon)
    // durumOverride: Opsiyonel - state yerine kullanılacak durum ID listesi
    const fetchHizmetForms = useCallback(async (showValidationError = false, durumOverride = null) => {
        // Kullanılacak durum listesini belirle
        const durumToUse = durumOverride || selectedDurum;
        
        if (showValidationError && durumToUse.length === 0) {
            setresponseMessage('Lütfen önce durum seçimi yapınız!');
            setUyariTip('error');
            setUyari(true);
            return;
        }

        const durumIdList = durumOverride 
            ? durumOverride.map(d => d.DURUM_ID ?? d.ID ?? d.Id ?? d).filter(id => typeof id === 'number' || (typeof id === 'string' && id !== '[object Object]'))
            : getDurumIdList(selectedDurum);
        
        if (durumIdList.length === 0) return;
        
        setLoading(true);
        try {
            const response = await axios.get(
                `GetApolloHizmetForm/${durumIdList.toString()}/${formattedBaslangicDate}/${formattedBitisDate}/${SessionUser.UserId}`
            );
            setDocuments(response.data || []);
        } catch (error) {
            console.error("Formlar yüklenirken hata:", error);
            setresponseMessage('Veriler yüklenirken bir hata oluştu');
            setUyariTip('error');
            setUyari(true);
            setDocuments([]);
        } finally {
            setLoading(false);
        }
    }, [selectedDurum, formattedBaslangicDate, formattedBitisDate, SessionUser.UserId]);

    // Sayfa yüklendiğinde (sadece dropdown verilerini getir)
    useEffect(() => {
        getServiceFormCategories();
        getLaborSteps();
    }, []);

    // Filtreleme ve arama
    const GeneralDataFiltreleAra = useCallback(() => {
        fetchHizmetForms(true);
    }, [fetchHizmetForms]);

    // ==========================================
    // EVENT HANDLERS
    // ==========================================

    const handleRequestSort = useCallback((property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    }, [order, orderBy]);

    const handleYorum = useCallback((row) => {
        setSelectedIndex(row.ID);
        setTarihcePopUp(true);
    }, []);

    // Form tamamlandığında
    const onComplete = useCallback(async (survey) => {
        setLoading(true);
        const data = {
            FormData: JSON.stringify(survey.data),
            FormType: 10,
            ServiceShopId: 0,
            UserId: SessionUser.UserId,
            Type: 5
        };
        
        try {
            const response = await axios.post('/SetApolloForm', data, {
                headers: { 'Content-Type': 'application/json' }
            });
            
            if (response.data?.ErrorCode === "OK") {
                setAnketBitti(true);
                setMesaj(response.data.ErrorDescription || "Form başarıyla kaydedildi.");
                setresponseMessage('Form başarıyla kaydedildi');
                setUyariTip('success');
                setUyari(true);
                setAnketGoster(false);
                
                // Listeyi yenile - filtre seçiliyse mevcut filtreyle, değilse tüm durumlarla
                if (selectedDurum.length > 0) {
                    await fetchHizmetForms(false, selectedDurum);
                } else if (durum.length > 0) {
                    // Tüm durumları seç ve ara
                    setSelectedDurum(durum);
                    await fetchHizmetForms(false, durum);
                } else {
                    // Durum listesi henüz yüklenmemişse tekrar yükle
                    const stepsResponse = await axios.get("/getLaborSteps");
                    if (stepsResponse.data && stepsResponse.data.length > 0) {
                        setDurum(stepsResponse.data);
                        setSelectedDurum(stepsResponse.data);
                        await fetchHizmetForms(false, stepsResponse.data);
                    }
                }
            } else {
                setAnketBitti(true);
                setMesaj(response.data?.ErrorDescription || "Bir hata oluştu.");
            }
        } catch (error) {
            console.error("Form kaydedilirken hata:", error);
            setAnketBitti(true);
            setMesaj("Sunucuya bağlanılamadı.");
        } finally {
            setLoading(false);
        }
    }, [SessionUser.UserId, fetchHizmetForms, selectedDurum, durum]);

    // Form popup kapat
    const handleAnketKapat = useCallback(() => {
        setAnketGoster(false);
    }, []);

    // Yeni form oluştur
    const handleCreateForm = useCallback(() => {
        if (!formTypes || formTypes.length === 0) {
            setresponseMessage('Form şablonu bulunamadı');
            setUyariTip('error');
            setUyari(true);
            return;
        }
        setAnketData(formTypes[0].Data);
        setAnketGoster(true);
        setReadOnly(false);
        setFormData({});
        setAnketBitti(false);
    }, [formTypes]);

    // Onay/Red popup aç
    const handleSinglePopUp = useCallback((row) => {
        setSelectedIndex(row.ID);
        setSelectedDurumId(row.DURUM_ID);
        setSinglePopUp(true);
        setYorumAciklama('');
    }, []);

    // Onay/Red kaydet
    const handleSave = useCallback(async (caseValue) => {
        // Validasyon
        if (!yorumAciklama || yorumAciklama.trim() === '') {
            setRequired(true);
            return;
        }

        const data = [{
            Id: selectedIndex,
            Yorum: yorumAciklama.trim(),
            UserId: SessionUser.UserId,
            Role_Id: 0,
            Durum: selectedDurumId,
            Case: caseValue
        }];

        setLoading(true);
        try {
            const response = await axios.post("SetApolloHizmetFormBasvuruOnay", data, {
                headers: { "Content-Type": "application/json" }
            });
            
            const res = response.data[0];
            setresponseMessage(res.ErrorDescription);
            setUyariTip(res.ErrorCode === "OK" ? "success" : "error");
            setUyari(true);
            setSinglePopUp(false);
            
            if (res.ErrorCode === "OK") {
                setRequired(false);
                // Listeyi yenile - filtre seçiliyse mevcut filtreyle, değilse ilk durumla veya tüm durumlarla
                if (selectedDurum.length > 0) {
                    await fetchHizmetForms(false, selectedDurum);
                } else if (durum.length > 0) {
                    // Tüm durumları seç ve ara
                    setSelectedDurum(durum);
                    await fetchHizmetForms(false, durum);
                } else {
                    // Durum listesi henüz yüklenmemişse tekrar yükle
                    const stepsResponse = await axios.get("/getLaborSteps");
                    if (stepsResponse.data && stepsResponse.data.length > 0) {
                        setDurum(stepsResponse.data);
                        setSelectedDurum(stepsResponse.data);
                        await fetchHizmetForms(false, stepsResponse.data);
                    }
                }
            }
        } catch (error) {
            console.error("Onay/Red işlemi sırasında hata:", error);
            setresponseMessage('İşlem sırasında bir hata oluştu');
            setUyariTip('error');
            setUyari(true);
        } finally {
            setLoading(false);
        }
    }, [yorumAciklama, selectedIndex, selectedDurumId, SessionUser.UserId, fetchHizmetForms, selectedDurum, durum]);

    // Slide transition fonksiyonu
    const SlideTransition = (props) => {
        return <Slide {...props} direction="down" />;
    };

    // Alert sınıfını belirle
    const getAlertClass = () => {
        switch (uyariTip) {
            case 'success':
                return classes.alertSuccess;
            case 'error':
                return classes.alertError;
            case 'warning':
                return classes.alertWarning;
            case 'info':
                return classes.alertInfo;
            default:
                return classes.alertInfo;
        }
    };

    // Durum chip sınıfını belirle
    const getDurumChipClass = (durumId) => {
        switch (durumId) {
            case 0: // Form Oluşturuldu
                return classes.statusInfo;
            case 1: // Onay Bekliyor - THKD
            case 3: // Onay Bekliyor - SKAY
            case 5: // Onay Bekliyor - SDKD
                return classes.statusPending;
            case 2: // Reddedildi - THKD
            case 4: // Reddedildi - SKAY
            case 6: // Reddedildi - SDKD
                return classes.statusRejected;
            case 7: // Tüm Onaylar Tamamlandı
                return classes.statusApproved;
            case 8: // İptal Edildi
                return classes.statusCanceled;
            default:
                return classes.statusPending;
        }
    };

    return (
        <Page className={classes.root}>
            <Backdrop className={classes.backdrop} open={loading}>
                <Box className={classes.backdropContent}>
                    <CircularProgress color="inherit" size={50} thickness={4} />
                    <Typography className={classes.loadingText}>
                        Yükleniyor...
                    </Typography>
                </Box>
            </Backdrop>
            <Snackbar
                open={uyari}
                autoHideDuration={6000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                TransitionComponent={SlideTransition}
                className={classes.snackbar}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={uyariKapat}
                    severity={uyariTip === 'default' ? 'info' : uyariTip}
                    className={getAlertClass()}
                >
                    {typeof responseMessage === 'string' ? responseMessage : responseMessage?.ErrorDescription || 'İşlem tamamlandı'}
                </MuiAlert>
            </Snackbar>
            <Container className={classes.container1} maxWidth="xl">
                <Card className={classes.mainCard}>
                    <CardHeader 
                        title={
                            <Box display="flex" alignItems="center">
                                <AssignmentIcon style={{ marginRight: 12 }} />
                                Hizmet/İşçilik Yönetimi
                            </Box>
                        }
                        className={classes.cardHeaderCustom}
                    />
                    <CardContent>
                        {/* Filtre Bölümü */}
                        <Paper className={classes.filterSection} elevation={0}>
                            <Typography variant="subtitle2" className={classes.filterTitle}>
                                <FilterListIcon />
                                Filtreleme Seçenekleri
                            </Typography>
                            
                            <Grid container spacing={2} alignItems="center">
                                {/* Durum */}
                                <Grid item xs={12} sm={6} md={3} lg={2}>
                                    <Autocomplete
                                        multiple
                                        size="small"
                                        id="multiple-limit-tags"
                                        fullWidth
                                        limitTags={1}
                                        disableCloseOnSelect
                                        value={selectedDurum}
                                        options={durum}
                                        getOptionLabel={option => (option.DURUM ? option.DURUM : '')}
                                        onChange={(event, newValue) => setSelectedDurum(newValue)}
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.DURUM}
                                            </React.Fragment>
                                        )}
                                        renderInput={params => (
                                            <TextField {...params} label="Durum" variant="outlined" />
                                        )}
                                    />
                                </Grid>

                                {/* Başlangıç Tarihi */}
                                <Grid item xs={12} sm={6} md={3} lg={2}>
                                    <ThemeProvider theme={materialTheme}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap['tr']}>
                                            <KeyboardDatePicker
                                                fullWidth
                                                size="small"
                                                color="primary"
                                                inputVariant="outlined"
                                                label="Başlangıç Tarihi"
                                                invalidDateMessage="Hatalı Tarih Formatı"
                                                format="dd.MM.yyyy"
                                                value={talepEdilmeBaslangicTarihi}
                                                onChange={date => setTalepEdilmeBaslangicTarihi(date)}
                                                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </ThemeProvider>
                                </Grid>

                                {/* Bitiş Tarihi */}
                                <Grid item xs={12} sm={6} md={3} lg={2}>
                                    <ThemeProvider theme={materialTheme}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap['tr']}>
                                            <KeyboardDatePicker
                                                fullWidth
                                                size="small"
                                                color="primary"
                                                inputVariant="outlined"
                                                label="Bitiş Tarihi"
                                                invalidDateMessage="Hatalı Tarih Formatı"
                                                format="dd.MM.yyyy"
                                                value={talepEdilmeBitisTarihi}
                                                onChange={date => setTalepEdilmeBitisTarihi(date)}
                                                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </ThemeProvider>
                                </Grid>

                                {/* Butonlar */}
                                <Grid item xs={12} sm={6} md={3} lg={6}>
                                    <Box display="flex" justifyContent="flex-end" flexWrap="wrap" style={{ gap: 12 }}>
                                        <Button
                                            className={classes.searchButton}
                                            variant="contained"
                                            onClick={() => GeneralDataFiltreleAra()}
                                            startIcon={<SearchIcon />}
                                        >
                                            Ara
                                        </Button>
                                        <Button
                                            className={classes.createButton}
                                            variant="contained"
                                            onClick={() => handleCreateForm()}
                                            startIcon={<AddIcon />}
                                        >
                                            Yeni Form Oluştur
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Paper>

                        {/* İstatistik Bölümü */}
                        <Box className={classes.statsSection}>
                            <Box className={classes.statsText}>
                                <ListAltIcon style={{ color: '#FF9800' }} />
                                <Typography variant="body2">
                                    Toplam Kayıt: <span className={classes.statsCount}>{documents.length}</span>
                                </Typography>
                            </Box>
                            <Typography variant="caption" color="textSecondary">
                                {selectedDurum.length > 0 
                                    ? `Seçili filtre: ${selectedDurum.map(d => d.DURUM).join(', ')}`
                                    : 'Filtre seçilmedi'
                                }
                            </Typography>
                        </Box>

                        {/* Tablo Bölümü */}
                        <TableContainer component={Paper} className={classes.tableContainer}>
                            <Table stickyHeader aria-label="sticky table" size="small">
                                <TableHead className={classes.tableHead}>
                                    <TableRow>
                                        <TableCell 
                                            align="left"
                                            sortDirection={orderBy === 'SURECTIPI' ? order : false}
                                        >
                                            <TableSortLabel
                                                active={orderBy === 'SURECTIPI'}
                                                direction={orderBy === 'SURECTIPI' ? order : 'asc'}
                                                onClick={() => handleRequestSort('SURECTIPI')}
                                            >
                                                Form Adı
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell 
                                            align="left"
                                            sortDirection={orderBy === 'DURUM' ? order : false}
                                        >
                                            <TableSortLabel
                                                active={orderBy === 'DURUM'}
                                                direction={orderBy === 'DURUM' ? order : 'asc'}
                                                onClick={() => handleRequestSort('DURUM')}
                                            >
                                                Mevcut Durum
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell 
                                            align="left"
                                            sortDirection={orderBy === 'SONRAKI_DURUM' ? order : false}
                                        >
                                            <TableSortLabel
                                                active={orderBy === 'SONRAKI_DURUM'}
                                                direction={orderBy === 'SONRAKI_DURUM' ? order : 'asc'}
                                                onClick={() => handleRequestSort('SONRAKI_DURUM')}
                                            >
                                                Sonraki Adım
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell 
                                            align="left"
                                            sortDirection={orderBy === 'SERVISBILGI' ? order : false}
                                        >
                                            <TableSortLabel
                                                active={orderBy === 'SERVISBILGI'}
                                                direction={orderBy === 'SERVISBILGI' ? order : 'asc'}
                                                onClick={() => handleRequestSort('SERVISBILGI')}
                                            >
                                                Açıklama
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center">Yorumlar</TableCell>
                                        <TableCell align="center">Form</TableCell>
                                        <TableCell align="left">Oluşturan</TableCell>
                                        <TableCell align="center">İşlemler</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {documents.length > 0 ? documents.map((row) => (
                                        <TableRow
                                            key={row.ID}
                                            className={`${classes.tableRow} ${row.ID === selectedIndex ? classes.tableRowSelected : ''}`}
                                        >
                                            <TableCell className={classes.tableCell}>
                                                <Typography variant="body2" style={{ fontWeight: 500 }}>
                                                    {row.FORM_ADI}
                                                </Typography>
                                            </TableCell>
                                            <TableCell className={classes.tableCell}>
                                                <Chip
                                                    size="small"
                                                    label={
                                                        row.DURUM_ID === 0 
                                                            ? (row.DURUM || '-') 
                                                            : (row.SONRAKI_DURUM?.split('›')[0]?.trim() || '-')
                                                    }
                                                    className={`${classes.statusChip} ${getDurumChipClass(row.DURUM_ID)}`}
                                                />
                                            </TableCell>
                                            <TableCell className={classes.tableCell}>
                                                <Chip
                                                    size="small"
                                                    label={
                                                        row.DURUM_ID === 0 
                                                            ? (row.SONRAKI_DURUM || '-') 
                                                            : (row.SONRAKI_DURUM?.split('›')[1]?.trim() || '-')
                                                    }
                                                    className={`${classes.statusChip} ${classes.statusInfo}`}
                                                />
                                            </TableCell>
                                            <TableCell className={classes.tableCell}>
                                                <Typography variant="body2" color="textSecondary">
                                                    {row.FORM_ACIKLAMA || '-'}
                                                </Typography>
                                            </TableCell>
                                            <TableCell className={classes.tableCell} align="center">
                                                <Tooltip title="Yorumları Görüntüle" arrow>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleYorum(row)}
                                                        className={`${classes.actionButton} ${classes.commentButton}`}
                                                    >
                                                        <CommentOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell className={classes.tableCell} align="center">
                                                <Tooltip title="Formu Görüntüle" arrow>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => {
                                                            setPrintAnket(false);
                                                            setReadOnly(true);
                                                            setAnketGoster(true);
                                                            setAnketData(row.AnketSoru);
                                                            setFormData(row.AnketCevap);
                                                            setAnketBitti(false);
                                                        }}
                                                        className={`${classes.actionButton} ${classes.viewFormButton}`}
                                                    >
                                                        <DescriptionIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell className={classes.tableCell}>
                                                <Typography variant="body2">
                                                    {row.ACIKLAMA || '-'}
                                                </Typography>
                                            </TableCell>
                                            <TableCell className={classes.tableCell} align="center">
                                                <Tooltip title="Onayla / Reddet" arrow>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleSinglePopUp(row)}
                                                        className={`${classes.actionButton} ${classes.approveButton}`}
                                                    >
                                                        <DoneAllIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Box className={classes.emptyState}>
                                                    <AssignmentIcon className={classes.emptyStateIcon} />
                                                    <Typography className={classes.emptyStateText}>
                                                        Henüz kayıt bulunmamaktadır
                                                    </Typography>
                                                    <Typography className={classes.emptyStateSubtext}>
                                                        Filtreleme yaparak kayıtları görüntüleyebilir veya yeni form oluşturabilirsiniz.
                                                    </Typography>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CardContent>
                    {/* Yorum Geçmişi Dialog */}
                    <Dialog
                        open={tarihcePopUp}
                        fullWidth
                        maxWidth="lg"
                        onClose={event => setTarihcePopUp(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        PaperProps={{ className: classes.dialogPaper }}
                    >
                        <Box className={classes.dialogTitleHistory}>
                            <Box display="flex" alignItems="center">
                                <HistoryIcon style={{ marginRight: 12 }} />
                                <Typography variant="h6" style={{ fontWeight: 600 }}>
                                    Yorum Geçmişi
                                </Typography>
                            </Box>
                            <IconButton
                                onClick={event => setTarihcePopUp(false)}
                                className={classes.dialogCloseButton}
                                size="small"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <DialogContent className={classes.dialogContent}>
                            <Tarihce BasvuruId={selectedIndex} readonly={false} OpenClose={5} />
                        </DialogContent>
                        <DialogActions className={classes.dialogActions}>
                            <Button
                                onClick={event => setTarihcePopUp(false)}
                                className={classes.closeButton}
                                startIcon={<CloseIcon />}
                            >
                                Kapat
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={filePopUp}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        maxWidth="md"
                    >
                        <DialogContent>
                            <Grid container spacing={2}>
                                <List>
                                    {fileList?.length ? fileList?.map((item, index) => (
                                        <ListItem key={item.DOSYA_ID}>

                                            <ListItemButton
                                                style={{ display: 'flex', cursor: 'pointer' }}
                                            >
                                                <ListItemIcon>

                                                    <FolderIcon style={{ color: '#424242' }} />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={<Typography type="body2"> {item.DOSYA_ADI}</Typography>}
                                                    onClick={() => {
                                                        setNewWindowOpen(item);
                                                        // setShowFile(true)
                                                        // setSelectedFile(row)
                                                    }}
                                                />
                                                <ListItemText
                                                    primary={item.ContentType}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    )) : !loading ? "Dosya Bulunmamaktadır." : "Dosyalar Yükleniyor..."}
                                </List>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    setFilePopUp(false);
                                }}
                                aria-label="close"
                                component="span"
                                variant="contained"
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={anketGoster}
                        onClose={() => handleAnketKapat()}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth={true}
                        disableBackdropClick={true}
                        fullScreen={true}
                    >
                        <Box className={classes.dialogTitle} style={{ padding: '12px 24px' }}>
                            <Box display="flex" alignItems="center">
                                <DescriptionIcon style={{ marginRight: 12 }} />
                                <Typography variant="h6" style={{ fontWeight: 600 }}>
                                    {readOnly ? 'Form Görüntüleme' : 'Yeni Form Oluştur'}
                                </Typography>
                            </Box>
                            <IconButton
                                onClick={() => handleAnketKapat()}
                                className={classes.dialogCloseButton}
                                size="small"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <DialogContent style={{ padding: 24 }}>
                            {loading ?
                                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight={300}>
                                    <CircularProgress size={50} style={{ color: '#FF9800' }} />
                                    <Typography style={{ marginTop: 16, color: '#666' }}>
                                        Yükleniyor...
                                    </Typography>
                                </Box>
                                : anketBitti ? 
                                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight={300}>
                                    <CheckCircleOutlineIcon style={{ fontSize: 80, color: '#4CAF50', marginBottom: 16 }} />
                                    <Typography variant="h6" style={{ color: '#4CAF50' }}>
                                        {mesaj}
                                    </Typography>
                                </Box>
                                    : printAnket ?
                                        <ServiceDigitalFormsPrint
                                            anketSoru={anketData}
                                            anketCevap={formData}
                                            formType={openedFormType}
                                        />
                                        :
                                        <>
                                            <ServiceDigitalForms
                                                anketSoru={anketData}
                                                anketCevap={formData}
                                                onComplete={onComplete}
                                                readonly={readOnly}
                                                serviceCodeQuestion={""}
                                                serviceNameQuestion={""}
                                                serviceFullNameQuestion={""}
                                                serviceShopFullName={""}
                                            />
                                        </>
                            }
                        </DialogContent>
                        <DialogActions className={classes.dialogActions}>
                            <Button
                                onClick={() => handleAnketKapat()}
                                className={classes.closeButton}
                                startIcon={<CloseIcon />}
                            >
                                Kapat
                            </Button>
                        </DialogActions>
                    </Dialog>
                    {/* Onay/Red Dialog */}
                    <Dialog
                        open={singlePopUp}
                        fullWidth
                        maxWidth="sm"
                        onClose={() => setSinglePopUp(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        PaperProps={{ className: classes.dialogPaper }}
                    >
                        <Box className={classes.dialogTitleApprove}>
                            <Box display="flex" alignItems="center">
                                <DoneAllIcon style={{ marginRight: 12 }} />
                                <Typography variant="h6" style={{ fontWeight: 600 }}>
                                    Onay / Red İşlemi
                                </Typography>
                            </Box>
                            <IconButton
                                onClick={() => setSinglePopUp(false)}
                                className={classes.dialogCloseButton}
                                size="small"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <DialogContent className={classes.dialogContent}>
                            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                                İşlem için bir yorum yazınız. Bu yorum kayıt geçmişinde görüntülenecektir.
                            </Typography>
                            <TextField
                                size="small"
                                id="desc"
                                autoComplete="off"
                                multiline
                                error={yorumAciklama?.length > 0 ? false : Required}
                                helperText={Required && !yorumAciklama ? 'Yorum alanı zorunludur' : ''}
                                rows={8}
                                value={yorumAciklama}
                                onChange={(event) => setYorumAciklama(event.target.value)}
                                fullWidth
                                label="Yorumunuz"
                                variant="outlined"
                                placeholder="Onay veya red sebebinizi yazınız..."
                                className={classes.commentField}
                            />
                        </DialogContent>
                        <DialogActions className={classes.dialogActions}>
                            <Button
                                onClick={() => handleSave(1)}
                                className={classes.rejectButton}
                                startIcon={<BlockIcon />}
                            >
                                Reddet
                            </Button>
                            <Button
                                onClick={() => handleSave(0)}
                                className={classes.approveButtonLarge}
                                startIcon={<CheckCircleOutlineIcon />}
                            >
                                Onayla
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Card>
            </Container>
        </Page>
    );
}
export default LaborManagement;
